var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"ueditor"},[_c('vue-ueditor-wrap',{attrs:{"config":_vm.myConfig},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_vm._v(" "+_vm._s(_vm.content)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }